import { Component, OnInit } from "@angular/core";
import { NavController, ModalController, IonicModule } from "@ionic/angular";
import { AcompanhamentoAddPage } from "./acompanhamento-add/acompanhamento-add.page";
import { AcompanhamentoFiltroPage } from "./acompanhamento-filtro/acompanhamento-filtro.page";
import { AcompanhamentoGerenciarPage } from "./acompanhamento-gerenciar/acompanhamento-gerenciar.page";
import { AcompanhamentoHistoricoPage } from "./acompanhamento-historico/acompanhamento-historico.page";
import { AcompanhamentoProvider } from "src/app/services/acompanhamento/acompanhamento";
import { Router } from "@angular/router";
import { addDays, format, isBefore, parseISO, subDays } from "date-fns";
import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { TranslateModule } from "@ngx-translate/core";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
@Component({
  selector: "app-acompanhamento",
  templateUrl: "./acompanhamento.page.html",
  styleUrls: ["./acompanhamento.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    LoadingSpinnerComponent,
    DateFormatPipe,
    TranslateModule,
    SemRegistroComponent,
  ],
})
export class AcompanhamentoPage implements OnInit {
  tipo: string = "acompanhamento";
  caseTipo: string = "meus";
  libera: boolean = false;
  atrasado: any;
  dateToCompare: any = format(new Date(), "yyyy-MM-dd");
  filtro = {
    dataFim: format(new Date(), "yyyy-MM-dd"),
    dataInicio: format(new Date(), "yyyy-MM-dd"),
    idAcompanhamentoOperacao: "0",
    idCategoria: "0",
    tipo: "0",
  };
  currentUrl: boolean;
  loaded = false;

  meusCompromissos: any = [];
  meusCompromissosBkp: any = [];
  meusAcompanhamentos: any = [];
  equipeAcompanhamentos: any = [];
  acompanhamentoAtrasados: any = [];

  constructor(
    public navCtrl: NavController,
    public acompanhamentoProvider: AcompanhamentoProvider,
    public router: Router,
    private location: Location,
    public modalCtrl: ModalController
  ) {
    const locationUrl = this.location.path();
    this.currentUrl = locationUrl === "/tabs/AcompanhamentoPage" ? true : false;
    this.isBuscar();
  }

  ngOnInit() {}

  isBuscar() {
    const atrasados: any[] = [];
    this.meusAcompanhamentos = [];
    this.equipeAcompanhamentos = [];
    this.acompanhamentoProvider.getAcompanhamentos(this.filtro).subscribe({
      next: (data) => {
        this.equipeAcompanhamentos = data.equipe;
        this.meusCompromissosBkp = data.meus.filter((item: { acao: string }) => item.acao === "COMPROMISSO");
        if (this.meusCompromissosBkp.length !== 0) {
          this.meusCompromissos = this.meusCompromissosBkp;
        }
        this.meusAcompanhamentos = data.meus.filter((item: { acao: string }) => item.acao !== "COMPROMISSO");

        this.meusAcompanhamentos.forEach((element: any) => {
          element.acompanhamentoAtrasado = this.isAtrasado(element.datahora) ? 1 : 0;
          element.acompanhamentoAtrasado === 1 ? atrasados.push(element) : null;
        });

        this.equipeAcompanhamentos.forEach((element: any) => {
          element.acompanhamentoAtrasado = this.isAtrasado(element.datahora) ? 1 : 0;
          element.acompanhamentoAtrasado === 1 ? atrasados.push(element) : null;
        });
        this.libera = atrasados.length > 0 ? true : false;
        this.acompanhamentoAtrasados = this.meusAcompanhamentos.filter((i: any) => i.acompanhamentoAtrasado == 1);

        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      },
      error: (err) => {
        console.error("Erro ao buscar o acompanhamento:", err);
        this.loaded = true;
      },
    });
  }

  async addAcompanhamento(tipo: any) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoAddPage,
      componentProps: { tipo: tipo },
      animated: false,
    });
    modalPage.present();

    const data = await modalPage.onWillDismiss();
    if (data) {
      await modalPage.dismiss(data.data);
    }
    this.isBuscar();
  }

  async gerenciar(acompanhamento: any, tipo: string) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoGerenciarPage,
      componentProps: { acompanhamento: acompanhamento, tipo: tipo, isResponsavel: true },
    });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.isBuscar();
    }
  }

  async detalhes(acompanhamento: any, tipo: string) {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoGerenciarPage,
      componentProps: { acompanhamento: acompanhamento, tipo: tipo, isResponsavel: false },
    });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.isBuscar();
    }
  }

  async historicoAcompanhamento() {
    (await this.modalCtrl.create({ component: AcompanhamentoHistoricoPage })).present();
  }

  isAtrasado(data: string) {
    const date = format(parseISO(data), "yyyy-MM-dd");
    const result = isBefore(new Date(date), new Date(this.dateToCompare));
    return result;
  }

  getFontColor(acompanhamento: { cor: any }) {
    return acompanhamento.cor;
  }

  getIcon(acompanhamento: { icone: string | string[] }) {
    return acompanhamento.icone.includes(" fa-") ? acompanhamento.icone : "fas fa-" + acompanhamento.icone;
  }

  async filtrar() {
    const modalPage = await this.modalCtrl.create({
      component: AcompanhamentoFiltroPage,
      componentProps: { filtro: this.filtro },
    });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.filtro = data;
      this.isBuscar();
      this.libera = false;
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  isPrimeiroAtrasado(lista: any[], index: number): boolean {
    return lista[index].acompanhamentoAtrasado === 1 && (index === 0 || lista[index - 1].acompanhamentoAtrasado !== 1);
  }

  isPrimeiroEmDia(lista: any[], index: number): boolean {
    return lista[index].acompanhamentoAtrasado === 0 && (index === 0 || lista[index - 1].acompanhamentoAtrasado !== 0);
  }
}
